import { ADD_ONEBET, GET_CURRENT_BETTING, SET_MUILT,SET_MAX_VALUE, SET_DELAY, SAMEMARKETALLOW, SET_LIVE_MULTI_ALLOW, SET_BETTED_ITEMS } from '../actions/types';

const initialState = {
   sportId: 0,
   eventKey: 0,
   bettedItems: [],
   currentBet: [],
   multiBetting: {}, 
   maxLength: 10,
   maxBetRate: 100,
   handicap_set: [],
   bet_multi: [],
   multiSetting: {},
   delaySetting: [],
   sameMarketAllow: false,
   liveMultiAllow: true,
}

export default function (state = initialState, action) {
   switch (action.type) {
      case ADD_ONEBET:
         return {
            ...state,
            sportId: action.payload.sportId,
            eventKey: action.payload.eventKey,
            bettedItems: action.payload.bettedItems,
            multiBetting: action.payload.multiBetting,
         }
      case GET_CURRENT_BETTING:
         return {
            ...state,
            currentBet: action.payload
         }
      case SET_MUILT:
         return {
            ...state,
            multiBetting: action.payload
         }
      case SET_MAX_VALUE:
         // //console.log(action.payload);
         return {
            ...state,
            maxLength: action.payload.multi_cnt,
            maxBetRate: action.payload.multi_max,
            handicap_set: action.payload.handicap_set,
            bet_multi: action.payload.bet_multi
         }
      case SET_DELAY:
         return {
            ...state,
            delaySetting: action.payload
         }
      case SAMEMARKETALLOW:
         return {
            ...state,
            sameMarketAllow: action.payload
         }
      case SET_LIVE_MULTI_ALLOW:
         return {
            ...state,
            liveMultiAllow: action.payload
         }
      case SET_BETTED_ITEMS:
         return {
            ...state,
            bettedItems: action.payload
         }
      default:
         return state;
   }
}


// WEBPACK FOOTER //
// ./src/common/reducers/betReducer.js